import styled from "styled-components";

export const MainCollectionsElement = styled.div``;

export const CollectionsHeading = styled.h2`
  font-style: normal;
  font-weight: 500;
  font-size: 4rem;
  line-height: 48px;
  color: #1a1a1a;
  margin-top: 60px;

  @media (max-width: 575.98px) {
    text-align: center;
  }
`;

export const CollectionsTable = styled.div`
  margin-top: 40px;

  @media (max-width: 575.98px) {
    margin-top: 20px;
  }

  .img-fluid {
    margin-left: 10px;
    margin-bottom: 3px;
  }

  .css-11xur9t-MuiPaper-root-MuiTableContainer-root {
    box-shadow: none;
  }

  .css-1ygcj2i-MuiTableCell-root {
    font-style: normal;
    font-weight: 600;
    font-size: 20px;
    line-height: 24px;
    color: #000000;
    border-bottom: 1px solid #f2f2f2;
  }

  .css-1azl6jz-MuiTableCell-root {
    font-style: normal;
    font-weight: 600;
    font-size: 20px;
    line-height: 24px;
    color: #000000;
    text-align: center;
    border-bottom: 1px solid #f2f2f2;
  }

  .css-1ex1afd-MuiTableCell-root {
    font-style: normal;
    font-weight: 500;
    font-size: 20px;
    line-height: 24px;
    color: #000000;
    border-bottom: 1px solid #f2f2f2;
    display: flex;
    justify-content: flex-start;
    align-items: center;
    gap: 20px;

    padding: 25px 0px;

    p {
      cursor: pointer;
    }

    input {
      height: 21px;
      width: 24px;
      margin-right: 15px;
      transform: translateY(4px);
    }
  }

  .css-177gid-MuiTableCell-root {
    font-style: normal;
    font-weight: 500;
    font-size: 20px;
    line-height: 23px;
    color: #000000;
    text-align: center;
    border-bottom: 1px solid #f2f2f2;

    .img-fluid {
      margin-right: 5px;
    }

    span {
      font-style: normal;
      font-weight: 400;
      font-size: 20px;
      line-height: 23px;
      color: #d35400;
      margin-left: 20px;
    }
  }
`;

export const CollectionsText = styled.h4`
  font-style: normal;
  font-weight: 500;
  font-size: 1rem;
  line-height: 48px;
  color: #1a1a1a;
  margin-top: 20px;

  @media (max-width: 575.98px) {
    text-align: center;
  }
`;

export const BtnContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  margin: 2rem 0rem;
`;

export const HorizontalBreak = styled.hr`
  color: #f2f2f2;
`;
